import React from "react";
import AddCustomerDetailsMobileView from "../../AddCustomerDetails/MobileView/AddCustomerDetailsMobileView ";
import AddRelocationDetailMobileView from "../../AddRelocationDetails/MobileView/AddRelocationDetailMobileView";
import AddPetDetailsMobileView from "../../AddPetDetails/MobileView/AddPetDetailsMobileView";
import { useEffect,useState } from "react";

function BookingFormPreviewMobileView({ setActiveForm }) {
  const OpenDocumentForm = () => {
    setActiveForm({
      customerDetails: false,
      relocationDetails: false,
      petDetails: false,
      preview: false,
      documentation: true,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked); // Update checkbox state
  };

  return (
    <div>
      <AddCustomerDetailsMobileView preview={true} />
      <AddRelocationDetailMobileView preview={true} />
      <AddPetDetailsMobileView preview={true} />
      <div className="main p-0">
        <div className="">
          <div
            style={{ backgroundColor: "white", borderRadius: "8px" }}
            className="container p-0 mt-4 d-flex justify-content-center align-items-baseline"
          >
            <input style={{ marginLeft: "17px" }} type="checkbox" onChange={handleCheckboxChange}/>
            <p
              style={{ fontSize: "14px", lineHeight: "23px", padding: "14px" }}
            >
              I hereby declare that I have thoroughly reviewed the above details
              and have filled in all the required information. I am ready to
              proceed with the further documentation and execution process for
              the pet transportation.
            </p>
          </div>
        </div>
      </div>

      <hr style={{ marginTop: "46px" }} />
      <div
        style={{ textAlign: "end" }}
        className="form-button-div mt-3 px-2 mb-4"
      >
        <button
          onClick={OpenDocumentForm}
          style={{
            paddingBottom: "5px",
            width: "150px",
            fontSize: "14px",
            backgroundColor: "#5B489D",
          }}
          type="submit"
          className="btn mb-4"
          disabled={!isChecked}
        >
          SAVE & NEXT <span style={{ fontSize: "20px" }}>&rarr;</span>
        </button>
      </div>
    </div>
  );
}

export default BookingFormPreviewMobileView;
